import { c as _c } from "react/compiler-runtime";
// File: @/components/content/status-message.tsx

import type { JSX, ReactNode } from 'react';
import { drawIcon } from '@/lib/design-elements';
interface StatusMessageProps {
  readonly title: string;
  readonly message: string;
  /** Extra actions rendered before the homepage link (e.g. "Try again"). */
  readonly children?: ReactNode;
}

/**
 * Shared layout for the 404 and error pages.
 *
 * The homepage link is a plain <a>, not next/link: on the error page a
 * full reload is the reliable way to recover, and on a single-page site a
 * client-side push to "/" while already on "/" would not remount anything.
 */
export function StatusMessage(t0) {
  const $ = _c(12);
  const {
    title,
    message,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h1>{title}</h1>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = <p>{message}</p>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-label">Go to the homepage</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a className="rectangular-button-link" href="/">{t3}<span className="icon">{drawIcon({
          iconName: "arrow"
        })}</span></a>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = <div className="status-message-actions">{children}{t4}</div>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t5) {
    t6 = <main className="content-container status-message" data-component="status-message">{t1}{t2}{t5}</main>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}